import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

// import { Globalization } from '@ionic-native/globalization/ngx';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.page.html',
  styleUrls: ['./change-language.page.scss'],
})
export class ChangeLanguagePage implements OnInit {

  // public name!: string;
  public language!: string;


  // public title1: string;
  // public title2: string;
  // public title3: string;
  // public title4: string;
  // public title5: string;
  // public title6: string;
  // public title7: string;
  // public title8: string;
  // public title9: string;
  // public title10: string;

  constructor(
    public modalCtrl: ModalController,

    // private globalization: Globalization, 
    // private _translate: TranslateService

    public addCall: AddCall,

  ) { }

  ngOnInit() {
  }



  // async languageChange() {
  //   this.modalCtrl.dismiss();
  // }


  // to translate language

  /*  ionViewDidEnter(): void {
     this.getDeviceLanguage()
   }
 
   _initialiseTranslation(): void {
     this._translate.get('title1').subscribe((res: string) => {
       this.title1 = res;
     });
     this._translate.get('title2').subscribe((res: string) => {
       this.title2 = res;
     });
     this._translate.get('title3').subscribe((res: string) => {
       this.title3 = res;
     });
     this._translate.get('title4').subscribe((res: string) => {
       this.title4 = res;
     });
     this._translate.get('title5').subscribe((res: string) => {
       this.title5 = res;
     });
     this._translate.get('title6').subscribe((res: string) => {
       this.title6 = res;
     });
     this._translate.get('title7').subscribe((res: string) => {
       this.title7 = res;
     });
     this._translate.get('title8').subscribe((res: string) => {
       this.title8 = res;
     });
     this._translate.get('title9').subscribe((res: string) => {
       this.title9 = res;
     });
     this._translate.get('title10').subscribe((res: string) => {
       this.title10 = res;
     });
     
 
   }
 
   public changeLanguage(): void {
     console.log("language", this.language);
 
     this._translateLanguage();
   }
 
   _translateLanguage(): void {
     this._translate.use(this.language);
     this._initialiseTranslation();
   }
 
   _initTranslate(language: any) {
     // Set the default language for translation strings, and the current language.
     this._translate.setDefaultLang('en');
     if (language) {
       this.language = language;
     }
     else {
       // Set your language here
       this.language = 'en';
     }
     this._translateLanguage();
   }
 
   getDeviceLanguage() {
     if (window.Intl && typeof window.Intl === 'object') {
       this._initTranslate(navigator.language)
     }
     else {
       this.globalization.getPreferredLanguage()
         .then(res => {
           this._initTranslate(res.value)
         })
         .catch(e => { console.log(e); });
     }
   } */


  async ChangeLanguage() {
    localStorage.setItem("selectedLanguage", this.addCall.language);
    // if(this.addCall.selectedLanguage == 'en'){

    // }
    this.modalCtrl.dismiss(this.addCall.language);
  }

}

